import { apiClient } from "./api";

/**
 * Fetches documents by type (e.g., privacy, terms)
 * @param type The type of document to fetch ("privacy" or "terms")
 * @returns The document data from the server
 */
export const fetchDocumentByType = async (
    type: "privacy" | "terms"
): Promise<any> => {
    try {
        const response = await apiClient.get(`/api/documents?type=${type}`);
        return response.data.document;
    } catch (error) {
        console.error(`Error fetching ${type} document:`, error);
        throw error;
    }
};